var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"expand":""}},_vm._l((_vm.displayedLayers),function(layer){return _c('wgu-layerlistitem',{key:layer.get('lid'),attrs:{"layer":layer,"mapView":_vm.map.getView(),"showLegends":_vm.showLegends,"showOpacityControls":_vm.showOpacityControls}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afdfa976","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layerlist/LayerList.vue
// module id = PSzQ
// module chunks = 1